import React from 'react';
import { useRecoilValue } from 'recoil';

import { openWindow } from '@ecp/common/src/utils/utils';
import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';

import { withMobileStatus } from '@mo-recoil/system/selector';
import {
  Container,
  InfoTextBox,
  SkypassFooterSubNoticeContainer,
  TextBold
} from '@ecp/mo/sites/skypass/styles/footer/SkypassFooterNoticeStyles';
import { Spacing } from '@ecp/common/src/layouts/Spacing';

export default function SkypassFooterNotice() {
  const { isMobileApp, agentType } = useRecoilValue(withMobileStatus);

  function onClickCurrentMilage() {
    openWindow(isMobileApp, 'https://www.koreanair.com/my-mileage/overview', '_blank', agentType);
  }

  return (
    <Container>
      <FlexBoxColumn align-items={'flex-start'}>
        <Spacing top={'30px'}/>
        <InfoTextBox size={'18px'} weight={'500'} height={'28px'}>알아두세요</InfoTextBox>
        <Spacing top={'4px'}/>
        <SkypassFooterSubNoticeContainer>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>구매 전 보유 마일리지를 확인해주시기 바랍니다.{' '}
            <InfoTextBox size={'11px'} onClick={onClickCurrentMilage} isEmphasize>
              마일리지 현황&gt;
            </InfoTextBox>
          </InfoTextBox>
          <InfoTextBox size={'11px'}><TextBold>•</TextBold>대한항공 홈페이지 회원 가입 및 로그인 후 이용 가능합니다.</InfoTextBox>
          <InfoTextBox size={'11px'}><TextBold>•</TextBold>본인의 보유 마일리지만 사용할 수 있으며, 가족합산은 불가합니다.</InfoTextBox>
          <InfoTextBox size={'11px'}><TextBold>•</TextBold>상품 구매취소나 환불 시, 유효기간이 지난 마일리지는 소멸되어</InfoTextBox>
          <InfoTextBox size={'11px'}>     환급되지 않습니다.</InfoTextBox>
          <InfoTextBox size={'11px'}><TextBold>•</TextBold>준비된 수량이 모두 판매되면 안내된 기간 전에 종료될 수 있습니다.</InfoTextBox>
          <InfoTextBox size={'11px'}><TextBold>•</TextBold>자세한 내용은 상품 상세 페이지를 참고해주세요.</InfoTextBox>
        </SkypassFooterSubNoticeContainer>
      </FlexBoxColumn>
    </Container>
  );
}
